import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import { Card } from '@/types/soap/elga/Card';
import { CardsState, RootState } from '@/store/types';

type Context = ActionContext<CardsState, RootState>;

export const cards: Module<CardsState, RootState> = {
    namespaced: true,
    state: {
        loaders: {
            cards: false,
        },
        cards: [],
    },
    actions: {
        loadCards({ commit, rootState }: Context): void {
            commit('setLoaders', { cards: true });

            const data = {
                impfstelle_id: rootState.authentication.impfstelle_id,
            };

            api.post('ivs/cards', data)
                .then((response) => commit('setCards', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoaders', { cards: false }));
        },
    },
    mutations: {
        setCards(state: CardsState, cards: Card[]): void {
            state.cards = cards;
        },
        setLoaders(state: CardsState, loaders: { cards?: boolean }): void {
            state.loaders = {
                ...state.loaders,
                ...loaders,
            };
        },
    },
};
